import React from 'react'
import { UseOfficerType } from './officerType'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'

export default (props: UseOfficerType) => {
    const {} = props
    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()

    return {
        projectData: manageProjectStore.projectData,
    }
}
